import React from "react";
import { connect } from "react-redux";
import { Div } from "components/Base";
import { getIsExpired, getIsDisabled } from "../selectors";

const decorate = connect(state => ({
  isDisabled: getIsDisabled(state),
  isExpired: getIsExpired(state)
}));

const CloseAt = ({ isExpired, isDisabled }) => {
  return isExpired || isDisabled ? (
    <Div bg="gray2" bra={2} p={3} mb={3} display="row.center.center">
      {isExpired
        ? "File uploads for this session are no longer being accepted"
        : `File uploads are not enabled for this session`}
    </Div>
  ) : null;
};

export default decorate(CloseAt);
